
function formatNumber(code, value) {
  return new Intl.NumberFormat(code).format(value)
}

export { formatNumber };
